{
  "title": "Drawmij's Instant Summons",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level conjuration (ritual)",
  "level": 6,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S, M (a sapphire worth 1,000 gp)",
  "duration": "Until dispelled",
  "description": [
    "You touch an object weighing 10 pounds or less whose longest dimension is 6 feet or less. The spell leaves an invisible mark on its surface and invisibly inscribes the name of the item on the sapphire you use as the material component. Each time you cast this spell, you must use a different sapphire.",
    "At any time thereafter, you can use your action to speak the item’s name and crush the sapphire. The item instantly appears in your hand regardless of physical or planar distances, and the spell ends. If another creature is holding or carrying the item, crushing the sapphire doesn’t transport the item to you, but instead you learn who the creature possessing the object is and roughly where that creature is located at that moment.",
    "Dispel Magic or a similar effect successfully applied to the sapphire ends this spell’s effect."
  ],
  "spellLists": ["wizard"]
}
